import { Link } from 'react-router-dom'
import Logo from '../images/demografica_logo.png'
import { FaLinkedinIn } from 'react-icons/fa'

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container footer__container">

        {/* IDENTIDAD */}
        <div className="footer__brand">
          <Link to="/" className="footer__logo">
            <img src={Logo} alt="Demográfica" />
          </Link>

          <p className="footer__description">
            Datos sociales para comprender el territorio.
          </p>

          <p className="footer__specialties">
            Demografía · Desigualdad · Pobreza · Salud pública ·
            Análisis territorial
          </p>
        </div>

        {/* NAVEGACIÓN */}
        <div className="footer__column">
          <h4>Explorar</h4>

          <Link to="/">Inicio</Link>
          <Link to="/about">Biografía académica</Link>
          <Link to="/gallery">Visualizaciones</Link>
          <Link to="/plans">Servicios</Link>
          <Link to="/censo">Censo 2024</Link>
        </div>

        {/* TRABAJO */}
        <div className="footer__column">
          <h4>Áreas de trabajo</h4>

          <span>Demografía y territorio</span>
          <span>Desigualdad y pobreza</span>
          <span>Análisis espacial y SIG</span>
          <span>Consultoría y docencia</span>
        </div>

        {/* CONTACTO */}
        <div className="footer__column footer__contact">
          <h4>Contacto</h4>

          <p>
            Consultoría, investigación y desarrollo de análisis
            basados en datos.
          </p>

          <Link to="/contact" className="footer__contact-link">
            Contactar →
          </Link>

          <div className="footer__socials">
            <a
              href="https://linkedin.com/"
              target="_blank"
              rel="noreferrer noopener"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>

      </div>

      <div className="container footer__bottom">
        <span>© 2026 Demográfica</span>
        <span>Santiago, Chile</span>
      </div>
    </footer>
  )
}

export default Footer